<div class="auth-container">
    @if (authorized) {
        <div class="success-card">
            <div class="success-icon-wrapper">
                @if (service === 'dropbox') {
                    <div class="brand-logo dropbox-logo">
                        <svg class="logo" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#0061FF">
                                <path d="M16 0L0 10.5L16 21L32 10.5L16 0Z"/>
                                <path d="M32 10.5L48 21L64 10.5L48 0L32 10.5Z"/>
                                <path d="M0 21L16 31.5L32 21L16 10.5L0 21Z"/>
                                <path d="M48 10.5L32 21L48 31.5L64 21L48 10.5Z"/>
                                <path d="M16 34.5L32 45L48 34.5L32 24L16 34.5Z"/>
                            </g>
                        </svg>
                    </div>
                } @else if (service === 'google') {
                    <div class="brand-logo google-logo">
                        <svg viewBox="0 0 48 48">
                            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                            <path fill="none" d="M0 0h48v48H0z"></path>
                        </svg>
                    </div>
                } @else {
                    <div class="success-icon">✓</div>
                }
            </div>
            <h2 class="success-title">Authorization Successful</h2>
            <p class="success-message">
                You have successfully authorized <strong>{{ service }}</strong>
            </p>
            <p class="token-info">
                Token has been securely stored
            </p>
            <div class="countdown-wrapper">
                <div class="clock-icon">⏱</div>
                <p class="countdown-text">
                    This window will close in <span class="countdown-number">{{ countdown }}</span> second{{ countdown !== 1 ? 's' : '' }}
                </p>
            </div>
        </div>
    } @else {
        <div class="error-card">
            <div class="error-icon-wrapper">
                <div class="error-icon">✕</div>
            </div>
            <h2 class="error-title">Authorization Failed</h2>
            <p class="error-message">
                Missing required parameters. Please try again.
            </p>
        </div>
    }
</div>